import * as tslib_1 from "tslib";
import { HttpHeaders } from '@angular/common/http';
import { PlatformEndpointService } from '../../endpoint/endpoint.service';
import { PlatformCommunicatorAuthService } from '../../platform-communicator/platform-communicator.auth.service';
import { PlatformCommunicatorService } from '../../platform-communicator/platform-communicator-onboarding.service';
import { SSOInformation } from './sso-information.model';
import { AbreCuentasService } from '../../../abre-cuentas/abre-cuentas.service';
import * as i0 from "@angular/core";
import * as i1 from "../../endpoint/endpoint.service";
import * as i2 from "../../platform-communicator/platform-communicator.auth.service";
import * as i3 from "../../platform-communicator/platform-communicator-onboarding.service";
import * as i4 from "../../../abre-cuentas/abre-cuentas.service";
var SsoService = /** @class */ (function () {
    function SsoService(endpointService, authService, platformCommunicatorService, abreCuentasService) {
        this.endpointService = endpointService;
        this.authService = authService;
        this.platformCommunicatorService = platformCommunicatorService;
        this.abreCuentasService = abreCuentasService;
    }
    SsoService.prototype.enableAPIGateway = function (grant_type, client_id, client_secret, userAccount, password) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var headers, body, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = new HttpHeaders({
                            'Content-Type': 'application/x-www-form-urlencoded',
                        });
                        body = new URLSearchParams();
                        body.set('grant_type', grant_type);
                        body.set('client_id', client_id);
                        body.set('client_secret', client_secret);
                        if (userAccount && password) {
                            body.set('username', userAccount);
                            body.set('password', password);
                        }
                        options = {
                            url: this.endpointService.URLS.API_GATEWAY_SSO,
                            method: 'post',
                            headers: headers,
                            body: body.toString(),
                        };
                        return [4 /*yield*/, this.platformCommunicatorService.request(options, false).then(function (response) {
                                var ssoInformation;
                                if (response.status !== 200) {
                                    return false;
                                }
                                if (response.body.access_token === undefined) {
                                    return false;
                                }
                                ssoInformation = new SSOInformation(response.body.access_token, response.body.expires_in, response.body.refresh_expires_in, response.body.refresh_token, response.body.token_type, response.body['not-before-policy'], response.body.session_state, response.body.scope);
                                _this.authService.saveSSOInformation(ssoInformation);
                                return true;
                            }, function (_error) {
                                return false;
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    SsoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SsoService_Factory() { return new SsoService(i0.ɵɵinject(i1.PlatformEndpointService), i0.ɵɵinject(i2.PlatformCommunicatorAuthService), i0.ɵɵinject(i3.PlatformCommunicatorService), i0.ɵɵinject(i4.AbreCuentasService)); }, token: SsoService, providedIn: "root" });
    return SsoService;
}());
export { SsoService };
